import { render, staticRenderFns } from "./Polkadot.vue?vue&type=template&id=6e14cdae&scoped=true&"
import script from "./Polkadot.vue?vue&type=script&lang=js&"
export * from "./Polkadot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e14cdae",
  null
  
)

export default component.exports